import { useEffect, useState } from 'react'

/**
 * How the application chat brings a message in, redrawn here: the row opens
 * from 0fr to 1fr, and only once it has does the content fade. The stagger is
 * the point — fading while growing reads as a glitch.
 */
export function FadeSlideIn({ children, className }: { children: React.ReactNode; className?: string }) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const frame = requestAnimationFrame(() => setVisible(true))
    return () => cancelAnimationFrame(frame)
  }, [])

  return (
    <div
      className={className}
      style={{
        display: 'grid',
        gridTemplateRows: visible ? '1fr' : '0fr',
        opacity: visible ? 1 : 0,
        transition: 'grid-template-rows .15s, opacity .15s .15s',
      }}
    >
      <div style={{ overflow: 'hidden' }}>{children}</div>
    </div>
  )
}
